import { render, staticRenderFns } from "./ivstplan.vue?vue&type=template&id=298ee1e0&scoped=true"
import script from "./ivstplan.vue?vue&type=script&lang=js"
export * from "./ivstplan.vue?vue&type=script&lang=js"
import style0 from "./ivstplan.vue?vue&type=style&index=0&id=298ee1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ee1e0",
  null
  
)

export default component.exports